import { GridRow } from './domain';

export interface MinusPhraseLibraryRow extends GridRow {
    name: string;
    minusKeywords: string;
    id: string;
    groupsCount: number;
}

export interface MinusPhraseLibraryGrid {
    data: Array<MinusPhraseLibraryRow>;
    allItemsIds: Array<string>;
    total: number;
    campaignsIds: string[];
}

export enum MinusPhraseLibraryModalType {
    edit = 'edit',
    create = 'create'
}

export enum MinusPhraseItemsActions {
    go = 'go'
}

export interface MinusPhrasesLibraryItem {
    name: string;
    id: string;
    preview: string;
}

export interface MinusPhrasesShortLibraryItem {
    name: string;
    id: string;
}

export interface MinusPhraseLibraryActions {
    onEdit: (index: string) => void;
    onCopyAndCreate: (index: string) => void;
    onDelete: (index: string) => void;
}

export enum MinusPhraseLibraryErrorsType {
    title = 'title',
    minusKeywords = 'minusKeywords',
    modal = 'modal',
    global = 'global'
}

export interface MinusPhraseEditListErrorsData {
    type: MinusPhraseLibraryErrorsType;
    message: string;
}
